export default {
  data() {
    return {
      ticketId: null,
    };
  },
  async mounted() {},
  methods: {
    submit() {
      this.$emit("submit", this.ticketId);
    },
  },
};
